var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { filterBy } from '../filtering/filter-expression.factory';
import { process } from '../array.operators';
import cloneDeep from 'lodash/cloneDeep';
import { toJS, comparer } from 'mobx';
export class InMemoryDataSource {
    constructor(data, idSelector, preprocessors = {}) {
        Object.defineProperty(this, "idSelector", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "preprocessors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cached", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = cloneDeep(toJS(data));
        this.idSelector = idSelector;
        this.preprocessors = preprocessors;
    }
    getData(state) {
        const { skip, take, sort, filter, group } = state;
        const sortedAndFiltered = this.cached && comparer.structural(this.cached.state, { sort, filter })
            ? this.cached.result
            : process(this.data, { sort, filter }, this.preprocessors);
        this.cached = {
            state: { sort, filter },
            result: sortedAndFiltered,
        };
        const { data } = process(sortedAndFiltered.data, { skip, take, group }, this.preprocessors);
        const { total } = sortedAndFiltered;
        return Promise.resolve({
            total,
            data: cloneDeep(data),
        });
    }
    addData(row, index) {
        if (index !== undefined) {
            this.data.splice(index, 0, cloneDeep(row));
        }
        else {
            this.data.push(cloneDeep(row));
        }
        this.cached = undefined;
        return Promise.resolve(cloneDeep(row));
    }
    updateData(id, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.idSelector) {
                throw 'missing idSelector';
            }
            const row = this.data.find(row => this.idSelector(row) === id);
            if (row) {
                Object.assign(row, changes);
                this.cached = undefined;
            }
            return Promise.resolve();
        });
    }
    removeData(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.idSelector) {
                throw 'missing idSelector';
            }
            const index = this.data.findIndex(row => this.idSelector(row) === id);
            if (index !== -1) {
                const row = this.data[index];
                this.data.splice(index, 1);
                this.cached = undefined;
                return Promise.resolve(row);
            }
        });
    }
    getFilteredPersistentItems(filter) {
        const set = new Set(this.data);
        const inFilter = filterBy(this.data, filter, this.preprocessors);
        inFilter.forEach(dataItem => set.delete(dataItem));
        return cloneDeep(Array.from(set));
    }
}
//# sourceMappingURL=in-memory-data-source.js.map